// extracted by mini-css-extract-plugin
module.exports = {"page":"river-3-ups-portable-power-station_page__caPGD"};